import posthog from 'posthog-js'

import { posthogBeforeSend } from './oneTimeTokenPrivacy'

let _enabled = false

export function initPostHog() {
  if (!import.meta.env.PROD || !import.meta.env.VITE_PUBLIC_POSTHOG_KEY) return

  try {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host:
        import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? 'https://t.beadedcloud.com',
      defaults: '2026-01-30', // Pins SDK default config to this date -- bump when upgrading posthog-js
      person_profiles: 'identified_only',
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      enable_heatmaps: true,
      // One-time tokens ride in /reset/<token> and /magic/<token> URLs, and
      // every event carries $current_url / $pathname.
      before_send: posthogBeforeSend,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-mask]',
      },
    })
    _enabled = true
  } catch {
    // PostHog init failed (likely blocked by adblocker) -- app continues without analytics
  }
}

export function isPostHogEnabled() {
  return _enabled
}

export { posthog }
